<!-- eslint-disable max-len -->
<template>
  <div>
    <LoadingSpinner v-if="loading" />

    <div v-if="!loading" class="block relative w-full mt-2">
      <div class="body_inners pl-4 pr-4">
        <div class="block top-block mb-4">
          <h2
            class="
              block
              text-darkgreen text-sm
              font-bold
              m-0
              title-block
              text-center
            "
          >
            {{ $t("pages.selected_application.title") }}
          </h2>
        </div>

        <div class="list-items block relative">
          <div
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
              mb-8
            "
            @click="$router.push({ name: 'CurrentFamily' })"
          >
            <div class="flex top-block mb-3 pt-4 pb-4 pl-3 pr-4">
              <div class="left-block w-2/4 relative">
                <h4 class="block relative text-sm font-bold text-darkblack">
                  {{ details.offer.customer.last_name }}/{{
                    details.offer.customer.first_name
                  }}
                </h4>
                <p
                  class="
                    flex
                    align-center
                    justify-start
                    mb-0
                    mt-1.5
                    text-xs
                    font-medium
                    text-darkgray1
                  "
                >
                  <span class="mr-1">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 10 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                        fill="#676666"
                      />
                    </svg>
                  </span>
                  {{ details.offer.location }}
                </p>
              </div>
              <div class="right-block w-2/4 relative">
                <p
                  class="
                    wishlist-icon
                    relative
                    text-sm text-right
                    flex
                    items-center
                    justify-end
                    font-bold
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 12 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.00016 0.833008C3.32418 0.833008 0.333496 3.8237 0.333496 7.49967C0.333496 11.1757 3.32418 14.1663 7.00016 14.1663C10.6761 14.1663 13.6668 11.1757 13.6668 7.49967C13.6668 3.8237 10.6761 0.833008 7.00016 0.833008ZM7.17334 3.83301C8.49667 3.83301 9.06307 4.39182 9.51774 4.84082C9.71441 5.03482 9.7163 5.35118 9.5223 5.54785C9.32863 5.74452 9.01127 5.74641 8.81527 5.55241C8.40827 5.15074 8.08699 4.83301 7.17399 4.83301C6.37166 4.83301 5.67077 5.37067 5.29443 6.16634H6.8335C7.1095 6.16634 7.3335 6.39001 7.3335 6.66634C7.3335 6.94267 7.1095 7.16634 6.8335 7.16634H5.01904C5.00771 7.27567 5.00016 7.38667 5.00016 7.49967C5.00016 7.61267 5.00771 7.72367 5.01904 7.83301H6.8335C7.1095 7.83301 7.3335 8.05667 7.3335 8.33301C7.3335 8.60934 7.1095 8.83301 6.8335 8.83301H5.29443C5.6711 9.62867 6.37101 10.1663 7.17334 10.1663C8.08634 10.1663 8.40793 9.84861 8.81527 9.44694C9.01127 9.25294 9.32863 9.25516 9.5223 9.4515C9.7163 9.64816 9.71441 9.96486 9.51774 10.1585C9.06307 10.6079 8.49699 11.1663 7.17399 11.1663C5.83132 11.1663 4.68353 10.1967 4.22087 8.83301H3.50016C3.22416 8.83301 3.00016 8.60934 3.00016 8.33301C3.00016 8.05667 3.22416 7.83301 3.50016 7.83301H4.01514C4.00647 7.72301 4.00016 7.61234 4.00016 7.49967C4.00016 7.38701 4.00647 7.27634 4.01514 7.16634H3.50016C3.22416 7.16634 3.00016 6.94267 3.00016 6.66634C3.00016 6.39001 3.22416 6.16634 3.50016 6.16634H4.22021C4.68322 4.80267 5.83101 3.83301 7.17334 3.83301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  {{ formatPrice(details.offer.compensation) }} Euro
                </p>
                <p
                  class="
                    flex
                    align-center
                    justify-end
                    mt-1.5
                    mb-0
                    text-xs
                    font-medium
                    text-darkgray1
                  "
                >
                  {{ $t("pages.common.buttons.dis15") }}:
                  {{
                    formatDate(
                      details.offer.arrival_date,
                      "DD.MM.YYYY",
                      "YYYY-MM-DD"
                    )
                  }}
                </p>
              </div>
            </div>
            <div
              class="
                flex
                items-center
                justify-start
                relative
                pt-3
                pb-3
                pl-3
                pr-3
                bg-lightgreen
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9464 1.14028C10.8847 1.07847 10.8115 1.02944 10.7308 0.995987C10.6502 0.962533 10.5637 0.945312 10.4764 0.945312C10.3891 0.945313 10.3026 0.962533 10.222 0.995987C10.1413 1.02944 10.0681 1.07847 10.0064 1.14028L4.35308 6.80028L1.99308 4.44028C1.86843 4.31562 1.69936 4.24559 1.52308 4.24559C1.34679 4.24559 1.17773 4.31562 1.05308 4.44028C0.928427 4.56493 0.858398 4.73399 0.858398 4.91028C0.858398 4.99756 0.875591 5.08399 0.908994 5.16464C0.942397 5.24528 0.991357 5.31855 1.05308 5.38028L3.87975 8.20694C4.13975 8.46694 4.55975 8.46694 4.81975 8.20694L10.9464 2.08028C11.2131 1.82028 11.2131 1.40028 10.9464 1.14028ZM1.99975 11.3336H9.99975C10.3664 11.3336 10.6664 11.0336 10.6664 10.6669C10.6664 10.3003 10.3664 10.0003 9.99975 10.0003H1.99975C1.63308 10.0003 1.33308 10.3003 1.33308 10.6669C1.33308 11.0336 1.63308 11.3336 1.99975 11.3336Z"
                    fill="#63B15B"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 font-medium">
                {{ $t("pages.common.buttons.dis123") }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="contactRecruiter">
          <h4
            class="
              flex
              align-start
              justify-start
              text-center text-darkgray1
              pt-5
              pb-5
              ml-2
              mr-2
            "
          >
            {{ $t("pages.application_process.warning.heading") }}
          </h4>

          <div
            class="
              block
              relative
              pl-4
              pr-4
              pt-2
              pb-5
              info-block
              walter-block
              bg-white
              rounded-lg
              walter-shadow
            "
          >
            <div class="flex align-start justify-start">
              <div class="block relative w-11 h-11 rounded-full">
                <img
                  src="./../../assets/images/fam-profile.png"
                  alt=""
                  class="w-full h-full rounded-full"
                />
              </div>
              <div class="block relative pl-4">
                <label
                  class="
                    flex flex-wrap
                    text-sm text-darkblack
                    capitalize
                    font-bold
                    mb-1.5
                    text-darkgray1
                  "
                >
                  Mateusz Walas
                  <span class="font-normal pl-1"> (osoba kontaktowa) </span>
                </label>

                <label
                  class="
                    flex
                    align-center
                    justify-start
                    text-sm
                    capitalize
                    font-normal
                    mb-2
                    text-darkgreen
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-4 h-4"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.95717 2.30161L0.978577 2.28823L3.68461 0.955078L6.60533 4.84936L5.26158 6.64114C5.30179 7.31687 5.58834 7.9544 6.067 8.43305C6.54566 8.9117 7.1832 9.19825 7.85892 9.23845L9.65067 7.8947L13.5449 10.8154L12.2229 13.4988L12.2117 13.5214L12.1983 13.5428C12.1278 13.6565 12.0293 13.7502 11.9123 13.8151C11.7953 13.8799 11.6636 13.9138 11.5298 13.9133H10.8315C9.48617 13.9133 8.15396 13.6483 6.911 13.1335C5.66803 12.6186 4.53864 11.864 3.58731 10.9127C2.63599 9.96133 1.88136 8.83194 1.36651 7.58898C0.851656 6.34601 0.586666 5.0138 0.58667 3.66842V2.97014C0.586242 2.83635 0.620065 2.70468 0.684917 2.58766C0.749771 2.47064 0.843495 2.37216 0.95717 2.30161ZM1.58667 3.66842C1.58667 8.76608 5.73392 12.9133 10.8315 12.9133H11.3965L12.2811 11.1176L9.65048 9.14464L8.18589 10.243H8.01923C7.0217 10.2419 6.06534 9.84517 5.35998 9.1398C4.65461 8.43444 4.25785 7.47808 4.25673 6.48055V6.31389L5.35514 4.84933L3.38239 2.21886L1.58667 3.10358V3.66842Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  71 584 652
                </label>

                <label
                  class="
                    flex
                    align-center
                    justify-start
                    text-sm
                    capitalize
                    font-normal
                    mb-2
                    text-darkgreen
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-4 h-4"
                      viewBox="0 0 14 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.4998 0.166992C12.6905 0.166992 13.6665 1.14301 13.6665 2.33366V8.66699C13.6665 9.85764 12.6905 10.8337 11.4998 10.8337H2.49984C1.30919 10.8337 0.33317 9.85764 0.33317 8.66699V2.33366C0.33317 1.14301 1.30919 0.166992 2.49984 0.166992H11.4998ZM11.4998 1.16699H2.49984C1.84982 1.16699 1.33317 1.68364 1.33317 2.33366V2.70215L6.99984 5.7653L12.6665 2.70215V2.33366C12.6665 1.68364 12.1499 1.16699 11.4998 1.16699ZM12.6665 3.83887L7.23747 6.77376C7.16447 6.81319 7.0828 6.83383 6.99984 6.83383C6.91687 6.83383 6.83521 6.81319 6.76221 6.77376L1.33317 3.83887V8.66699C1.33317 9.31701 1.84982 9.83366 2.49984 9.83366H11.4998C12.1499 9.83366 12.6665 9.31701 12.6665 8.66699V3.83887Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  mateusz.walas@gmail.com
                </label>

                <label
                  class="
                    flex
                    align-center
                    justify-start
                    text-sm
                    capitalize
                    font-normal
                    mb-0
                    text-darkgray1
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-4 h-4"
                      viewBox="0 0 14 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.99984 0.833008C10.6758 0.833008 13.6665 3.8237 13.6665 7.49967C13.6665 11.1757 10.6758 14.1663 6.99984 14.1663C3.32386 14.1663 0.33317 11.1757 0.33317 7.49967C0.33317 3.8237 3.32386 0.833008 6.99984 0.833008ZM6.99984 1.83301C3.8643 1.83301 1.33317 4.36414 1.33317 7.49967C1.33317 10.6352 3.8643 13.1663 6.99984 13.1663C10.1354 13.1663 12.6665 10.6352 12.6665 7.49967C12.6665 4.36414 10.1354 1.83301 6.99984 1.83301ZM7.17432 3.49251C7.30681 3.49458 7.43307 3.54916 7.52535 3.64425C7.61764 3.73934 7.6684 3.86718 7.6665 3.99967V7.99967C7.66649 8.13228 7.61381 8.25945 7.52004 8.35321C7.42628 8.44698 7.29911 8.49966 7.1665 8.49967H4.49984C4.43358 8.50061 4.3678 8.48837 4.30631 8.46366C4.24483 8.43896 4.18887 8.40228 4.14169 8.35575C4.0945 8.30923 4.05703 8.2538 4.03146 8.19267C4.00589 8.13154 3.99272 8.06594 3.99272 7.99967C3.99272 7.93341 4.00589 7.86781 4.03146 7.80668C4.05703 7.74555 4.0945 7.69012 4.14169 7.64359C4.18887 7.59707 4.24483 7.56039 4.30631 7.53569C4.3678 7.51098 4.43358 7.49874 4.49984 7.49967H6.6665V3.99967C6.66554 3.93275 6.67803 3.86632 6.70322 3.80431C6.7284 3.7423 6.76578 3.68598 6.81314 3.63869C6.8605 3.59139 6.91687 3.55408 6.97891 3.52898C7.04095 3.50387 7.1074 3.49147 7.17432 3.49251Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  {{ $t("pages.common.buttons.dis5") }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group mb-4" v-if="!contactRecruiter">
          <button
            class="
              w-full
              flex
              items-center
              justify-center
              btn_apply
              rounded-lg
              text-white
              btn_action
              mb-5
            "
            @click="reject"
          >
            {{ $t("pages.common.buttons.dis6") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner";
import moment from "moment";

export default {
  name: "SelectedApplication",
  components: { LoadingSpinner },
  data() {
    return { contactRecruiter: false };
  },
  computed: {
    ...mapGetters("application", {
      details: "selected",
    }),
  },
  methods: {
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    reject() {
      let diff = moment(this.details.offer.arrival_date)
        .local()
        .diff(moment().local(), "days");

      let daysLeft;

      if (diff === 0) {
        daysLeft = moment(this.details.offer.arrival_date)
          .local()
          .diff(moment().local(), "hours");

        this.contactRecruiter = true;
      } else if (diff > 0 && diff <= 3) {
        daysLeft = diff;
        this.contactRecruiter = true;
      } else {
        this.contactRecruiter = false;

        this.$store.commit("app/showNotification", {
          heading: this.$t("pages.common.buttons.dis124"),
          buttons: {
            okay: {
              text: this.$t("pages.common.buttons.dis176"),
              action: () => {
                this.loading = true;
                this.$store
                  .dispatch("application/reject", this.details.offer.offer_id)
                  .then(() => {
                    this.loading = false;
                    this.$router.push({ name: "Applications" });
                  });
              },
            },
            cancel: {
              text: this.$t("pages.common.buttons.dis8"),
              action: () => {
                this.loading = false;
              },
            },
          },
        });
      }
    },
  },
};
</script>
